import { authTokenCache } from './auth-token';

// A page-lifetime JWT locked SDRs out of reconnecting mid-shift and cost live calls,
// so mint per connect.

// A function, not a const: reading `window` at import time breaks tests that load
// useCockpit.
function bffWsBase(): string {
  const configured: string | undefined = import.meta.env.VITE_BFF_WS_BASE;
  if (configured) return configured;
  const scheme = import.meta.env.DEV ? 'ws' : 'wss';
  return `${scheme}://${window.location.host}`;
}

// What this bundle guarantees, sent to the BFF as `?cv=`. Mirrors COCKPIT_PROTOCOL_V2
// in apps/bff/src/cockpit/protocol.ts, which documents why the handshake exists.
export const COCKPIT_PROTOCOL_VERSION = 3;

// A failed mint yields a TOKENLESS url rather than null: the callers' backoff handles
// the 1008, whereas null would strand them with no socket and no retry.
// `kind` tells the BFF what this socket IS: 'ping' (the health probe) may observe but
// never hold a seat — without the mark the BFF once adopted a left seat onto the ping
// socket, which then kept it alive unattended (see Session.kind in the BFF manager).
export async function getFreshWsUrl(
  impersonateSdr: string | null,
  kind: 'cockpit' | 'ping' = 'cockpit',
): Promise<string> {
  const token = await authTokenCache.get().catch(() => null);
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (impersonateSdr) params.set('sdr', impersonateSdr);
  params.set('cv', String(COCKPIT_PROTOCOL_VERSION));
  params.set('kind', kind);
  const query = params.toString();
  return `${bffWsBase()}/bff/ws${query ? `?${query}` : ''}`;
}

// Call on a 1008: without this the retry replays the token the BFF just rejected
// until the TTL lapses.
export function invalidateWsToken(): void {
  authTokenCache.invalidate();
}
